export enum RiderTypeCode {
    DriverPassenger = 'KELEIV',
    HelpOnRoadPlus = 'MTPLASB',
    ExtendedHelpOnRoad = 'MTPLASE',
    CascoMtplRider = 'CB175101',
    TechnicalAssistance = 'TECH_PAG',
    DriverPassengerLiability = 'VAIR_KELEIV',
}
